<template>
  <div class="messages-view-layout">
    <SessionsBar />
    <MainPanel />
  </div>
</template>

<script>
import SessionsBar from '../components/SessionsBar.vue'
import MainPanel from '../components/MainPanel.vue'

export default {
  name: 'MessagesView',
  components: { SessionsBar, MainPanel }
}
</script>

<style scoped>
.messages-view-layout {
  display: contents;
}
</style>
